import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Loader from '../../Global/Loader';
import { useNavigate } from 'react-router-dom';
function ModalInProcess({ isOpen, onClose, consultation, consultant, fetchConsultants,
  fetchConsultations }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    consultationId: '',
    studentName: '',
    email: '',
    date: '',
    time: '',
    consultantId: '',
    meetingLink: ''
  });

  // Update the useEffect
  useEffect(() => {
    if (consultation) {
      setFormData({
        ...formData,
        consultationId: consultation.consultationId || '',
        studentName: consultation.studentName || '',
        email: consultation.email || '',
        date: consultation.consultationDate || '',
        time: consultation.consultationTime || '',
        consultantId: consultation.consultantId || '',
        meetingLink: consultation.meetingLink || '',
        status: consultation.status || ''
      });
    }
  }, [consultation]); // Add consultation as dependency
  // console.log(consultation.time)
  // console.log(consultation.date);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const isFormComplete = () => {
    return Object.values(formData).every(value => value !== '');
  };
  ;



  // Update the handleBook function
  const handleBook = async () => {
    if (!isFormComplete()) {
      alert('Please fill all fields before booking');
      return;
    }

    try {
      setLoading(true);
      // Check if admin is selected
      if (formData.consultantId === 'admin') {
        await axios.patch(
          `${process.env.REACT_APP_BASE_URL}/consultation/${consultation._id}/update`,
          {
            consultantName: 'Admin',
            consultationDate: formData.date,
            consultationTime: formData.time,
            meetingLink: formData.meetingLink,
            status: "Booked"
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
          }
        );
      } else {
        await axios.patch(
          `${process.env.REACT_APP_BASE_URL}/consultation/${consultation._id}/update`,
          {
            consultantId: formData.consultantId,
            consultationDate: formData.date,
            consultationTime: formData.time,
            meetingLink: formData.meetingLink,
            status: "Booked"
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
          }
        );
      }

      // Only call fetch functions if they exist

      fetchConsultants()
      fetchConsultations()
      setIsSubmitted(true);
      handleClose();
    } catch (error) {
      setError(true);
      // console.error('Error updating consultation:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      consultationId: '',
      studentName: '',
      email: '',
      date: '',
      time: '',
      consultantId: '',
      meetingLink: ''
    });
    setLoading(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      {loading && <Loader />}
      {
        isSubmitted && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
              {/* Modal Content */}
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Success!
              </h2>
              <h4 className="text-sm text-gray-600 mb-6">
                Your application has been submitted successfully.
              </h4>
              <div className="flex justify-end space-x-4">
                {/* Proceed Button */}
                <button
                  onClick={() => setIsSubmitted(null)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        error && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
              {/* Modal Content */}
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Something went wrong!
              </h2>
              <h4 className="text-sm text-gray-600 mb-6">
                We encountered an issue while processing your request. Please try again later. If the problem persists, contact support.
              </h4>
              <div className="flex justify-end space-x-4">
                {/* Proceed Button */}
                <button
                  onClick={() => setError(null)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )
      }
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="p-6 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-semibold">Consultation Details</h2>
            <button
              onClick={handleClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>

        {/* Content - Scrollable */}
        <div className="p-6 overflow-y-auto">
          <form id="consultationForm" onSubmit={(e) => e.preventDefault()}>
            {/* Non-editable Information Section */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <h3 className="text-lg font-medium mb-4">Basic Information</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Consultation ID</label>
                  <p className="mt-1 text-sm text-gray-900">{formData.consultationId}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Student Name</label>
                  <p className="mt-1 text-sm text-gray-900">{formData.studentName}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Email</label>
                  <p className="mt-1 text-sm text-gray-900">{formData.email}</p>
                </div>
              </div>
            </div>

            {/* Editable Information Section */}
            <div className="bg-white border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-4">Consultation Details</h3>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
                    <input
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Time</label>
                    <input
                      type="time"
                      name="time"
                      value={formData.time}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Consultant</label>
                  <select
                    name="consultantId"
                    value={formData.consultantId}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="" hidden>Select Consultant</option>
                    <option value="admin" className="font-medium text-blue-600">
                      Admin
                    </option>
                    {consultant.map((c) => (
                      <option
                        key={c._id}
                        value={c._id}
                      >
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Meeting Link</label>
                  <input
                    type="url"
                    name="meetingLink"
                    value={formData.meetingLink}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="https://meet.google.com/..."
                  />
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="p-6 border-t mt-auto">
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-700 rounded hover:bg-gray-700 hover:text-white"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleBook}
              disabled={loading || !isFormComplete()}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
            >
              {loading ? 'Processing...' : 'Book Consultation'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ModalInProcess;